<div class="w-full flex flex-col sm:flex-row gap-2 items-center justify-between px-4 py-2">
  <div class="flex flex-nowrap items-center gap-2">
    <lib-logo />
    <div class="text-center text-xs text-medium text-nowrap py-1">&copy; {{ year }} SmallSalon v{{ version }}</div>
  </div>
</div>
